import pipe from "@insightfulscience/shared-utils/fn/pipe";
import routes, { navToPath } from "../routes";
import { withLoading } from "../nprogress";
import { ref } from "../persistent-storage";
import { SUBSCRIPTION } from "../purchaseTypes";
import { isAuthorized } from "../services/auth";

export const savePriceItem = context => (planCode, seats, price) =>
	ref(context).PriceItem.write({ purchaseType: SUBSCRIPTION, planCode, seats, price });

const gotoBillingInfo = ({ planCode, seats, price }, routerAction) => {
	savePriceItem()(planCode, seats, price);

	const urlToRedirect = isAuthorized()
		? routes.billingInfo
		: `${routes.login}?returnUrl=${encodeURIComponent(routes.billingInfo)}`;

	return navToPath(urlToRedirect, urlToRedirect, routerAction);
};

export default pipe(gotoBillingInfo, withLoading("select-seats-action"));
